import { Common } from '@stockbit/ui';

import { lotSize } from 'global/TradingModal/constant';

import { formatNumber, formatPercentage } from 'utils/number';
import { getColorBasedOnNumber } from 'utils/general';
import {
  getBuyAmountInvested,
  getProfitLoss,
  getSellAmountInvestedFee,
  getSellGain,
} from 'global/Securities/utils/formula';
import realTradingStore from '../store';

const { Flex, Text } = Common;

interface ProfitLossProps {
  priceAverageFee: number;
  isCorporateAction: boolean;
}

function ProfitLoss({ priceAverageFee, isCorporateAction }: ProfitLossProps) {
  const { price, shares } = realTradingStore();
  const lot = shares / lotSize;

  const sellAmountInvestedFee = getSellAmountInvestedFee(
    lot,
    price,
    isCorporateAction,
  );
  const buyAmountInvestedAveragePriceFee = getBuyAmountInvested(
    lot,
    priceAverageFee,
  );
  const sellProfitLoss = getProfitLoss(
    sellAmountInvestedFee,
    buyAmountInvestedAveragePriceFee,
  );
  const sellGain = getSellGain(
    sellProfitLoss,
    buyAmountInvestedAveragePriceFee,
  );

  return (
    <Flex
      align="center"
      justify="center"
      px="20px"
      py="16px"
      style={{
        border: '1px solid #dadada',
        borderRadius: '5px',
        minWidth: '320px',
      }}
    >
      <Flex justify="space-between" width="100%">
        <Text>Profit/Loss</Text>
        <Text color={getColorBasedOnNumber(sellProfitLoss)}>
          {formatNumber(sellProfitLoss, false)} ({sellProfitLoss > 0 && '+'}
          {sellGain === Infinity ? '0.0%' : formatPercentage(sellGain, false)})
        </Text>
      </Flex>
    </Flex>
  );
}

export default ProfitLoss;
